import React from 'react';
import PropTypes from 'prop-types';
import FilterCards from './FilterCards';

const SubmissionFilters = ({ filters, selected, setFilter, data }) => {
  const filterObj = filters.map((statusItem) => {
    let count = data.length || 0;
    if (count > 0 && statusItem !== 'All') {
      if (statusItem === 'New') {
        count = data.filter(
          (datum) => datum.status === 'new' || datum.status === 'New' || !datum.status,
        ).length;
      } else {
        count = data.filter(
          (datum) => datum.status === statusItem,
        ).length;
      }
    }

    return {
      name: statusItem,
      count,
    };
  });

  return (
    <FilterCards
      filters={filterObj}
      selected={selected}
      setFilter={setFilter}
    />
  );
};

SubmissionFilters.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.object),
  selected: PropTypes.number,
  setFilter: PropTypes.func,
  data: PropTypes.array,
};

export default SubmissionFilters;
